function validateEmail(email) {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(email)
}

function footerChangeLang(value) {
  window.postMessage({
    type: 'CHANGE_LOCALE',
    payload: {locale: value}
  }, location.href)
}
export { validateEmail }
export { footerChangeLang }



// WEBPACK FOOTER //
// ./src/utils/validation.js